module.exports = [
	{
		"fileName": "1.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer."
	},
	{
		"fileName": "2.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer."
	},
	{
		"fileName": "3.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer."
	},
	{
		"fileName": "4.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "5.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "6.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "7.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "8.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "9.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "10.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "11.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer. "
	},
	{
		"fileName": "12.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer.  "
	},
	{
		"fileName": "13.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer.  "
	},
	{
		"fileName": "14.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer.  "
	},
	{
		"fileName": "15.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer.  "
	},
	{
		"fileName": "16.jpg",
		"title": "Heaven of time",
		"desc": "Here he comes Here comes Speed Racer.  "
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/imageDatas.json
 ** module id = 141
 ** module chunks = 0
 **/